import React from 'react';
import Head from 'next/head';

type Props = {
    data : Record<string, unknown> | Record<string, unknown>[];
    id ?: string;
};

const JsonLd : React.FC<Props> = ({ data, id }) => {
    return (
        <Head>
            <script
                type='application/ld+json'
                id={id}
                dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
            />
        </Head>
    );
};

export default JsonLd;
